import { useEffect } from "react";

// Adds a small IntersectionObserver-driven reveal to any element with [data-reveal].
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]:not(.revealed)");
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
}
